import Product from '@/creditflowresearch/domain/Product/Product';
import AbsProduct from '@/creditflowresearch/domain/Product/entities/AbsProduct';
import type { IProductSelectionContext } from '@/creditflowresearch/domain/Product/selectors/selectDefaultAbsProduct';

export const selectDefaultProductFallback = (context: IProductSelectionContext): string => {
  if (!context.hasAccess) {
    const product = Product.from(AbsProduct.PRODUCT_ID);
    return product?.getId() || AbsProduct.PRODUCT_ID;
  }

  const absProduct = Product.from(AbsProduct.PRODUCT_ID);
  if (!absProduct) {
    return AbsProduct.PRODUCT_ID;
  }

  const accessibleProducts = context.accessibleProductIds
    .map((id) => Product.from(id))
    .filter((product): product is Product => product !== null);

  if (absProduct.canAccessWith(accessibleProducts)) {
    return absProduct.getId();
  }

  return context.accessibleProductIds[0] || absProduct.getId();
};
